import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Box } from 'rebass'

const Main = ({ children }) => (
  <Flex flexDirection="column" style={{ minHeight: `100vh` }}>
    <Box is="main" flex="1">
      {children}
    </Box>
  </Flex>
)

Main.propTypes = {
  children: PropTypes.node,
}

export default Main



// WEBPACK FOOTER //
// ./src/containers/Layout/Main.js